import { createContext, useState } from "react";
import { CreateHook } from "utils/utils";

const UserSettingsContext = createContext();

const useUserSettings = () =>
  CreateHook("useUserSettings", UserSettingsContext);

const UserSettingsContextProvider = ({ children }) => {
  const [showTips, setShowTips] = useState(false);

  return (
    <UserSettingsContext.Provider
      value={{
        showTips,
        setShowTips,
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
};

export { UserSettingsContextProvider, useUserSettings };
